<template>
  <content-dashboard :hide="true">
    <v-col cols="12" md="12" sm="12">
      <v-card>
        <v-card-title class="subtitle-1">Filtros</v-card-title>
        <v-card-text>
          <p>Status: <b>{{ statusAuto }}</b></p>
          <p>Total: <b>{{ paginate.total }} Autos</b></p>
          <p>Data: <b>{{ $route.query.data_inicial | data }} - {{ $route.query.data_final | data }}</b></p>

          <v-form ref="form" v-if="status_detran.length">
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-select
                  hide-details
                  dense
                  outlined
                  v-model="$route.query.status_detran"
                  label="Status"
                  :items="status_detran"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        
        <v-card-actions class="justify-center" v-if="status_detran.length">
          <v-btn color="primary" @click="load($route.query)">Pesquisar</v-btn>
          <v-btn color="primary" outlined class="ml-5" @click="reset">Limpar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col>
      <v-card>
        <v-card-title class="subtitle-1">Autos Status</v-card-title>
        <v-card-text>
          <v-data-table :loading="loading" no-data-text="Selecione um filtro" :headers="headers" :items="items" hide-default-footer :items-per-page="50">
            <template v-slot:item.created_at="{ item }">{{ item.created_at | data }}</template>

            <!-- <template v-slot:item.codigo="{ item }">{{ item.codigo && item.digito ? `${item.codigo}-${item.digito}` : '---' }}</template> -->

            <template v-slot:item.placa="{ item }">{{ item.veiculo_placa }}</template>

            <template v-slot:item.renainf="{ item }">{{ item.renainf ? item.renainf : '---' }}</template>

            <template v-slot:item.infracao_data="{ item }">{{ item.data_infracao }}</template>

            <template v-slot:item.prazo_envio="{ item }">{{ data_limite[item.id_auto] | data }}</template>
            
            <template v-slot:item.prioridade="{ item }"><v-badge inline :color="prioridades != undefined ? prioridades[item.id_auto] : ''"></v-badge></template>

            <template v-slot:item.dias_restantes="{ item }">{{ dias_restantes != undefined ? dias_restantes[item.id_auto] : '---' }}</template>
            
            <template v-slot:item.status="{ item }">{{ item.status ? item.status : '---' }}</template>
            
            <template v-show="filename" v-slot:item.filename="{ item }">{{ item.arquivo && item.arquivo[0] ? item.arquivo[0].arquivo.filename : '---' }}</template>

            <template v-show="duplicidades.length" v-slot:item.duplicidade="{ item }">{{ duplicidades != undefined && duplicidades[item.id_auto] > 1 ? 'Sim' : 'Não' }}</template>

            <template v-show="actions" v-slot:item.actions="{ item }">
              <v-icon color="success" class="mr-2" @click="showAuto(item)">mdi-eye</v-icon>
            </template>
            <template v-slot:top>
              <v-btn v-if="permissoes.auditoria_exportar"
                @click="download($route.query)"
                color="primary"
                dark
                class="mb-2"
              >
                Exportar dados
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-pagination
            color="primary"
            v-model="paginate.current_page"
            :length="paginate.last_page"
            :total-visible="10"
            @input="load($route.query, $event)"
          >
          </v-pagination>
        </v-card-actions>
      </v-card>
    </v-col>
    <modal-detalhes-auto
      v-if="showModalDetalhesAuto"
      :permissoes="permissoes"
      :perfil="user.perfil.perfil"
      :show="showModalDetalhesAuto"
      :auto="autoDetalhe"
      @fechar="showModalDetalhesAuto = false"
      @visualizar-notificacao="openNotificacaoPdf($event)"
    ></modal-detalhes-auto>
  </content-dashboard>
</template>
<script>
import queryString from "querystring";
import urlApi from "@/routes/urlApi";
import { showError } from "@/global";
import { mapState } from "vuex";

export default {
  name: "Autos",
  components: {
    ModalDetalhesAuto: () => import("@/components/Modal/ModalDetalhesAuto")
  },
  data() {
    return {
      statusAuto: null,
      showModalDetalhesAuto: false,
      filename: false,
      actions: false,
      autoDetalhe: {},
      loading: false,
      paginate: {},
      items: [],
      data_limite: [],
      prioridades: [],
      dias_restantes: [],
      duplicidades: [],
      status_detran: [],
      headers: [
        { text: "Número Auto", value: "numero_auto" },
        // { text: "Infração", value: "codigo" },
        { text: "Placa", value: "placa" },
        { text: "Renainf", value: "renainf" },
        { text: "Descrição", value: "descricao_breve" },
        { text: "Data Infração", value: "infracao_data" },
        { text: "Prazo Envio", value: "prazo_envio" },
        { text: "Prioridade", value: "prioridade" },
        { text: "Dias Restantes", value: "dias_restantes" },
        { text: "Status Detran", value: "status" },
        { text: "Arquivo", value: "filename" },
        { text: "Duplicidade", value: "duplicidade" },
        { text: "Ações", value: "actions" },
      ]
    };
  },
  created() {
    this.load(this.$route.query, 1);
    this.loadStatusAuto(this.$route.query.id_status_auto);
  },
  computed: {
    ...mapState("user", ["permissoes", "user"])
  },
  methods: {
    load(filtro, page) {
      this.$store.commit("overlay/toggle", true);
      this.loading = true;
      
      const filter = queryString.stringify(filtro);
      const url = `${urlApi}/auditoria/autos/status/all?${filter}&page=${page}`;
      
      this.$http.get(url).then(res => {
        const response      = res.data.dados;
        this.items          = response.autos.data;
        this.data_limite    = response.data_limite;
        this.prioridades    = response.prioridade;
        this.dias_restantes = response.dias_restantes;
        this.paginate       = response.autos;
        this.duplicidades   = response.duplicidade;
        this.filename       = response.arquivo;

        response.status_detran.forEach((dataStatus) => {
          this.status_detran.push({text: dataStatus.status, value: dataStatus.id_status_detran});
        });

        this.loading = false;
        this.$store.commit("overlay/toggle", false);
      }).catch(showError);
    },

    loadStatusAuto(id) {
      const url = `${urlApi}/statuses/${id}`;
      this.$http.get(url).then(res => {
        this.statusAuto = res.data.status_auto;
        //   console.log(res.data);
        //   this.items = res.data.data;
        //   this.paginate = res.data;
        //   this.loading = false;
      }).catch(showError);
    },

    async showAuto(item) {
      this.$store.commit("overlay/toggle", true);

      const { id_auto } = item;

      try {
        const data = await this.$http.get(`${urlApi}/autos/${id_auto}`);
        this.$store.commit("overlay/toggle", false);
        this.autoDetalhe = { ...data.data.dados };
        this.toggleModalDetalhesAuto();
      } catch (err) {
        this.$store.commit("overlay/toggle", false);
        showError("Não foi possível carregar os detalhes");
      }
    },

    toggleModalDetalhesAuto() {
      this.showModalDetalhesAuto = !this.showModalDetalhes;
    },

    reset() {
      this.filtro = {};
    },
    download(filtro) {
      if (!this.permissoes.auditoria_exportar) {
        showError("Você não possui permissão");
        return;
      }
      const filter = queryString.stringify(filtro);
      const url = `${urlApi}/auditoria/autos/status/all/exportar?${filter}`;
      window.open(url, `"_self"`);
    }
  }
};
</script>
